import Layout from "../../components/global/layout";
import "./style.scss";
import { Tooltip } from "antd";
import { HiOutlineArrowDown } from "react-icons/hi";
import SelectDropdown from "../../components/common/SelectDropdown";
import statusModel from "../../models/status.model";
import { LiaEdit } from "react-icons/lia";

const Html = ({
  clear,
  view,
  edit,
  ChangeStatus,
  statusChange,
  deleteItem,
  filters,
  data,
  isAllow,
  total = { total },
  user
}) => {
  return (
    <Layout>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h3 className="text-2xl font-semibold text-[#111827]">Roles</h3>
        </div>
        <div className="flex items-center gap-2">
          {/* <Link className="bg-primary leading-10 h-10 flex items-center shadow-btn px-6 hover:opacity-80 text-sm text-[#222222d6] rounded-lg gap-2" to="/roles/add">
            <FiPlus className="text-xl text-[#fff]" /> Add Role
          </Link> */}
          <SelectDropdown
            id="statusDropdown"
            displayValue="name"
            placeholder="All Status"
            intialValue={filters.status}
            result={(e) => {
              ChangeStatus(e.value);
            }}
            options={statusModel.list}
          />
          {filters.status && <button className="bg-primary leading-10 h-10 inline-block shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg" onClick={() => clear()}>Reset</button>}
        </div>
      </div>
      <>
        <div className="shadow-box w-full bg-white rounded-lg">
          <div className="scrollbar w-full overflow-auto">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 capitalize bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr className="">
                  <th scope="col" className="px-6 py-4">
                    Role Name
                  </th>
                  <th scope="col" className="px-6 py-4">Status</th>
                  <th scope="col" className="px-6 py-4">Action</th>
                </tr>
              </thead>
              <tbody>
                {data && data.map((itm, i) => {
                  return (
                    <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600" key={i}>
                      <td className={`px-6 py-4 capitalize`}>{itm.name}</td>
                      <td className="px-6 py-4">
                        <div className="w-32" onClick={() => statusChange(itm)}>
                          <span className={`${itm?.name != "sub admin" && "cursor-pointer"} text-sm cursor-pointer !px-3 h-[30px] w-[100px] flex items-center justify-center border border-[#EBEBEB] text-[#fff] !rounded capitalize ${itm.status == "deactive" ? " bg-gray-200 text-black" : "bg-[#F58D18]"}`}>
                            {itm.status == "deactive" ? "inactive" : "active"}
                          </span>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center justify-start gap-1.5">
                          {isAllow(`editRoles`) && itm?.name != "sender" && user?.role?.name != "sub admin" && (
                            <Tooltip placement="top" title="Edit">
                              <a className="border cursor-pointer hover:opacity-70 rounded-lg bg-[#F58D1814] w-10 h-10 !text-primary flex items-center justify-center text-lg" onClick={(e) => edit(itm?.id || itm?._id)}><LiaEdit /></a>
                            </Tooltip>
                          )}
                          {/* {isAllow("deleteRoles") && (
                            <Tooltip placement="top" title="Delete">
                              <span className="border cursor-pointer hover:opacity-70 rounded-lg bg-[#F58D1814] w-10 h-10 !text-primary flex items-center justify-center text-lg" onClick={() => deleteItem(itm?.id || itm?._id)}>
                                <LiaTrashAlt />
                              </span>
                            </Tooltip>
                          )} */}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </>
    </Layout>
  );
};

export default Html;
